import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'app/models2/administration/user';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { FuelOrder } from 'app/models2/fuel/fuel-order';
import { NotificationsService } from 'app/services/notifications.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { FunctionsService, HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService } from 'brainloper-ui';

@Component({
  selector: 'app-fuel-order-notification',
  templateUrl: './fuel-order-notification.component.html',
  styleUrls: ['./fuel-order-notification.component.scss']
})
export class FuelOrderNotificationComponent implements OnInit {
  
  private urlPostFO: string = `${EndpointDictionary.HistoricalFuel.CRUD_HISTORICAL_FUEL_DATA}`
  private urlCloseFO: string = `${EndpointDictionary.HistoricalFuel.HISTORICAL_FUEL_CLOSE}`


  public formCloseOrder: UntypedFormGroup
  private order
  public bodyOrden: FuelOrder = {}
  public bodyUsuarios: User[] = []
  public activa: number = 0
  public buttonActive: boolean = false
  public view: boolean = false
  public rol: string = this.storage.get<string>('rol')
  public currentOdometer: number = 0;
  public istraccarDevice: boolean = false;

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: this.rol == 'Administrativo' || this.rol == 'root' || this.rol == 'Jefe Mantenimiento' ? "Ordenes de Combustible" : "O.C",
      router: this.rol == 'Administrativo' || this.rol == 'root' || this.rol == 'Jefe Mantenimiento' ? '/combustible/autoriza_comb' : null,
    },
    {
      name: "Cierre Combustible",
      current: true
    }
  ]

  constructor(
    private activeRoute: ActivatedRoute,
    private http: HttpService,
    private message: MessageService,
    private functioEter: FunctionsService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private functionEter: FunctionsService,
    private storage: LocalStorageService,
    private notificationsService: NotificationsService,
  ) {
    this.formCloseOrder = this.formBuilder.group(
      {
        orderId: '',
        totalPrice: '',
        gallonPrice: '',
        billNumber: '',
        gallons: '',
        salesOrder: '',
        currentOdometer: 0
      }
    )
  }

  ngOnInit(): void {
    this.init()
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando información')
    this.activeRoute.queryParamMap
      .subscribe(async (params) => {
        this.order = { ...params };


        let res: Array<FuelOrder> = await this.http.getDataBody(`${this.urlPostFO}/${this.order.params.id_orden}`)
        if (res) {
          this.bodyOrden = res[0]
          this.bodyOrden.date = this.functioEter.dateIso(res[0].date)
          this.formCloseOrder.controls.orderId.setValue(this.bodyOrden.id)
          this.formCloseOrder.controls.gallons.setValue(this.bodyOrden.gallons)
          this.formCloseOrder.controls.totalPrice.setValue(this.bodyOrden.totalPrice)
          this.formCloseOrder.controls.currentOdometer.setValue(this.bodyOrden.currentOdometer)
          this.currentOdometer = this.bodyOrden.currentOdometer
          
          // Deshabilitar el campo odómetro si existe traccarDeviceId
          this.istraccarDevice = !!this.bodyOrden.traccarDeviceId;
          if (this.istraccarDevice) {
            this.formCloseOrder.controls.currentOdometer.disable();
          }
          
          this.view = true
          this.message.closeLoading()
        } else {
          this.message.Error('Error', res['message'])
          this.message.closeLoading()
        }
      }
      )
  }


  async closeOrder(form: FuelOrder) {
    this.buttonActive = true
    this.message.openLoading('Cargando', 'Cerrando Orden de Combustible')

    let res: Array<FuelOrder> = await this.http.getDataBody(`${this.urlPostFO}/${this.order.params.id_orden}`)
    if (res) {
      if (res[0].active == 1) {
        let fuelOrder: FuelOrder = res[0]
        for (let controls of Object.keys(form)) {
          if (controls === 'currentOdometer' && this.istraccarDevice) {
            // Si el odómetro está deshabilitado, mantener el valor original
            fuelOrder[controls] = res[0].currentOdometer
          } else {
            fuelOrder[controls] = form[controls]
          }
        }
        fuelOrder.date = this.functionEter.dateForm(res[0].date)
        this.closeFO(fuelOrder)
      } else {
        this.message.closeLoading()
        this.message.Warning('Advertencia', 'Esta orden ya fue cerrada')
        this.deleteFuelNotificationByUrl()
        setTimeout(() => {
          this.router.navigate(['/inicio'])
        }, 500);

      }
    }

  }

  close() {
    this.activa = 1
  }

  async closeFO(form: FuelOrder) {
    try {
      form.active = 0

      let messageError = null

      if (form.gallons <= 0)
        messageError = "Los Galones deben ser mayor a 0"

      if (!this.istraccarDevice && this.currentOdometer >= form.currentOdometer) {
        let msm = "El odómetro/horómetro debe ser mayor que " + this.currentOdometer.toLocaleString()
        messageError = messageError ? messageError + " y " + msm : msm;
      }

      if (messageError) {
        this.message.Error("Error", messageError)
        this.message.closeLoading()
        this.buttonActive = false
        return
      }

      let res: GenericResponse = await this.http.putDataBody(`${this.urlCloseFO}`, form)
      if (res) {
        this.deleteFuelNotificationByUrl()
        this.message.closeLoading()
        setTimeout(() => {
          this.router.navigate(['/inicio'])
        }, 500);

      } else {
        this.message.closeLoading()
        this.message.Error('Error', res['message'])
      }
    } catch (error) {
      this.message.closeLoading()
      this.message.Error('Error', error)
    }
  }

  private deleteFuelNotificationByUrl() {
    this.notificationsService.deleteNotificationByUrl(`notificaciones/ordenCombustible?id_orden=${this.order.params.id_orden}`)
  }

  errorMessage() {
    this.message.Error('Error', 'complete los campos')
  }

  calculatePrice() {
    if (this.formCloseOrder.controls.gallons.value != "" && this.formCloseOrder.controls.gallonPrice.value != "") {
      let galones = parseInt(this.formCloseOrder.controls.gallons.value)
      let precioGal = parseInt(this.formCloseOrder.controls.gallonPrice.value)
      this.formCloseOrder.controls.totalPrice.setValue((galones * precioGal).toString())

    }
  }

}
